import React, { useContext } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import AuthProvider from './common/security/AuthProvider';
import IdentityProvider from './common/security/IdentityProvider';
import AppRoute from './common/routing/AppRoute';
import Login from './app/Login/Login';
import Home from './app/Home/Home';
import HomeAPI from './app/HomeAPI/HomeAPI';
import { SessionProvider } from './common/session/SessionContext';
import AppConfiguration, { AppConfigContext } from './common/config/AppConfiguration';
import AddDocumentAPI from './app/AddDocumentAPI/AddDocumentAPI';

function AppContent() {
  const config = useContext(AppConfigContext) || {};
  const authenticationUrl = config && config.authenticationUrl;
  return (
    <AuthProvider authenticationUrl={authenticationUrl}>
      <IdentityProvider>
        <SessionProvider>
          <Switch>
            <AppRoute path="/HomeAPI" isAnonymous={true}> 
              <HomeAPI/>
            </AppRoute>
            <AppRoute path="/add-document-api" isAnonymous={true}>
              <AddDocumentAPI/>
            </AppRoute>
            <AppRoute path="/login/:idp?" isAnonymous={true}>
              <Login />               
            </AppRoute>
            <AppRoute path="/">
              <Home />
            </AppRoute>
          </Switch>
        </SessionProvider>
      </IdentityProvider>
    </AuthProvider>
  );
}

function App() {
  return (
    <AppConfiguration>
      <Router>
        <AppContent />
      </Router>
    </AppConfiguration>
  );
}

export default App;
